import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_team_management-multi_user_evergreen_homepage_banner_avatars-click';

/**
 * A click event for the multi user evergreen homepage banner&#39;s avatars
 */
export function trackRetailerTeamManagementMultiUserEvergreenHomepageBannerAvatarsClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
